import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export default class CacheService {
    private cache = new Map<string, CacheItem>();

    getCacheItem<T>(key: string): T | null {
        const cacheEntry = this.cache.get(key);
        if (cacheEntry) {
            if (cacheEntry.hasExpired()) {
                this.invalidateCacheItem(key); // Invalidate expired cache
            } else {
                return cacheEntry.data as T;
            }
        }

        return null;
    }

    addOrReplaceCacheItem<T>(key: string, item: T, expiration: Date | null = null): T | null {
        try {
            this.cache.set(key, new CacheItem(item, expiration));
            return item;
        } catch (error) {
            console.debug(error);
        }

        return null;
    }

    invalidateCacheItem(key: string): boolean {
        return this.cache.delete(key);
    }
}

class CacheItem {
    public data: any;
    private expiration: Date | null;

    constructor(data: any, expiration: Date | null) {
        this.data = data;
        this.expiration = expiration;
    }

    hasExpired(): boolean {
        if (this.expiration === null) {
            return false;
        }

        return this.expiration < new Date();
    }
}
